<ng-container *ngIf="doMatSelect; else nativeSelect">
    <mat-form-field class="single-select btn btn-outline-secondary d-flex flex-nowrap text-nowrap">
        <mat-select panelClass="single-select-panel mat-menu-panel mat-elevation-z4"
                    [(value)]="selectedRange"
                    (selectionChange)="selectionChanged()">
            <mat-option *ngFor="let range of ranges"
                        [value]="range">{{ range }}</mat-option>
        </mat-select>
    </mat-form-field>
</ng-container>

<ng-template #nativeSelect>
    <div class="d-inline-block profit-report">
        <select (change)="selectionChanged()"
                [formControl]="range"
                class="form-control form-control-sm">
            <option *ngFor="let r of ranges" value="{{ r }}">
                {{ r }}
            </option>
        </select>
    </div>
</ng-template>

<button *ngIf="!filterOnChange"
        class="btn btn-primary py-2 ml-1"
        (click)="getReport()">
    {{ 'Go' }}
</button>
